import ScrollView from "./scrollView";

export default ScrollView;
